import { render, staticRenderFns } from "./SpecimenSelectionTable.vue?vue&type=template&id=656e633c&scoped=true"
import script from "./SpecimenSelectionTable.vue?vue&type=script&lang=js"
export * from "./SpecimenSelectionTable.vue?vue&type=script&lang=js"
import style0 from "./SpecimenSelectionTable.vue?vue&type=style&index=0&id=656e633c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e633c",
  null
  
)

export default component.exports